import PassportNew from "./PassportNew";
import VisaNew from "./VisaNew";

const Travels = ({
  personalInfo,
  passportDetails,
  visaDetails,
  handleGetTableData,
  empPublicId,
  getEmployeeRegistrationData,
  currentEmployeeEditing = false,
}) => {
  return (
    <div>
      {/* Passport Section */}
      <PassportNew
        personalInfo={personalInfo}
        passportDetails={passportDetails}
        visaDetails={visaDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
      />

      <div className="h-1 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded my-8" />

      {/* Visa Section - Only if not a citizen */}
      {personalInfo?.citizen === "false" && (
        <VisaNew
          personalInfo={personalInfo}
          visaDetails={visaDetails}
          handleGetTableData={handleGetTableData}
          empPublicId={empPublicId}
          getEmployeeRegistrationData={getEmployeeRegistrationData}
          currentEmployeeEditing={currentEmployeeEditing}
        />
      )}
    </div>
  );
};

export default Travels;
